import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/Index'
import Login from './views/login/index'
import AssessCreate from './views/assess/Create'
import Layout from './views/Layout'
import Oauth2 from './plugins/auth'
import Users from './views/users/Index'
import Download from './views/download/Index'
// Vue.use(OAuth2)

// import router from "../../app.bak/src/router";
Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: Layout,
            redirect: '/home',
            meta: {requiresAuth: true},
            children: [
                {
                    path: '/home',
                    component: Home,
                    name: 'home',
                    meta: {requiresAuth: true}
                },
                {
                    path: '/create-assess/:id?',
                    component: AssessCreate,
                    name: 'create-assess',
                    meta: {requiresAuth: true}
                },
                {
                    path: '/users',
                    component: Users,
                    name: "users",
                    meta: {requiresAuth: true}
                }
            ],
        },
        {
            path: '/download',
            name: 'download',
            component: Download,
            meta: {requiresAuth: true}
        },
        { path: '/logout',
            beforeEnter (to, from, next) {
                this.$oauth2.logout();
                next('/')
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
    ]
})
//
router.beforeEach((to, from, next) => {
    // eslint-disable-next-line
    if (to.matched.some(r => r.meta.requiresAuth)) {
        if (!Oauth2.Oauth2Client.isAuthenticated()) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router